export const DEV_CONFIG = {
    cdn: {
        contentCDN: 'https://cdn-dev.public.zooplus.net',
    },
};
